<template>
  <el-dialog title="素材详情" @close="onModalClose" @open="onModalOpen" :visible.sync="state" width="1100px" :close-on-click-modal="false">
    <div v-loading="loading" class="material-detail-container">
      <div class="material-grid">
        <!-- Video / Meta / Shot / AI Remix Layout -->
        <template
          v-if="
            imageType === IMAGE_TYPES.VIDEO ||
            imageType === IMAGE_TYPES.META ||
            imageType === IMAGE_TYPES.SHOT ||
            imageType === IMAGE_TYPES.AI_REMIX
          "
        >
          <!-- Preview Section -->
          <div class="grid-item-span-2">
            <div class="material-wrapper">
              <video
                v-if="imageType === IMAGE_TYPES.META"
                ref="materVideoRef"
                :src="formItem.field1"
                controls="controls"
                crossorigin="anonymous"
                class="video-item"
                @timeupdate="onVideoPlayUpdateTimeStamp"
              ></video>

              <video
                v-else-if="imageType === IMAGE_TYPES.SHOT"
                ref="materVideoRef"
                :src="formItem.field1"
                controls="controls"
                crossorigin="anonymous"
                class="video-item"
              ></video>

              <video
                v-else
                ref="materVideoRef"
                :src="formItem.field1 + '?t=' + Math.random()"
                controls="controls"
                crossorigin="anonymous"
                class="video-item"
              ></video>
            </div>

            <div class="similar-shot-preview" v-if="imageType === IMAGE_TYPES.SHOT">
              <div class="video-box" @click="onSimilarVideoPlay({ url: formItem.field1 })">
                <span class="score">分镜</span>
                <video :src="formItem.field1"></video>
              </div>
              <div class="video-box" @click="onSimilarVideoPlay(video)" v-for="(video, index) in similarShotPreviewList" :key="index">
                <span class="score">{{ video.score }}</span>
                <video preload="auto" :src="video.url"></video>
              </div>

              <div class="redo" @click="getShotMaterialItems">
                <span>
                  <span v-if="similarSearchLoading" class="el-icon-loading"></span>
                  <span v-else class="el-icon-refresh"></span>
                  重新查找
                </span>
              </div>
            </div>
          </div>

          <!-- Info / Subtitle Section -->
          <div class="grid-item-span-2">
            <SubtitleDisplayForm
              v-model="subtitleList"
              v-if="imageType === IMAGE_TYPES.META"
              :id="formItem.id"
              @subtitle-edit="onSubtitleEdit"
            ></SubtitleDisplayForm>

            <div class="shot-detail" v-else-if="imageType === IMAGE_TYPES.SHOT">
              <h3>分段片段详情</h3>
              <div v-if="aiContent.video_desc">
                <p v-if="aiContent.video_desc.name">
                  <span class="title">分镜名称：</span>
                  <span>{{ aiContent.video_desc.name }}</span>
                </p>
                <p>
                  <span class="title">关键元素：</span>
                  <span>{{ aiContent.video_desc.key_elements.join('、') }}</span>
                </p>

                <p>
                  <span class="title">画面描述：</span>
                  <span>{{ aiContent.video_desc.visual_core }}</span>
                </p>

                <p>
                  <span class="title">内容标签：</span>
                  <span>{{ aiContent.video_desc.emotion_atmosphere }}</span>
                </p>

                <p>
                  <span class="title">叙事重点：</span>
                  <span>{{ aiContent.video_desc.content_narrative_focus }}</span>
                </p>
              </div>
            </div>

            <div v-else class="material-wrapper">
              <img :src="formItem.addr" class="item-background" />
              <img :src="formItem.addr" :class="[formItem.width >= formItem.height * 1.76 ? 'img-item-cross' : 'img-item-vertical']" />
            </div>
          </div>

          <!-- Action Buttons -->
          <template v-if="[IMAGE_TYPES.VIDEO, IMAGE_TYPES.META, IMAGE_TYPES.REMIX_AUDIT_PRE].includes(imageType)">
            <div class="grid-item-span-2 action-container">
              <el-upload action="" :before-upload="videoFileUploader" style="display: inline-block">
                <el-button>替换视频</el-button>
              </el-upload>
              <el-button type="primary" class="g-pull-right" icon="el-icon-video-pause" @click="handleParse" v-if="false">
                暂停/设置视频封面
              </el-button>
            </div>
            <div class="grid-item-span-2" v-if="imageType !== IMAGE_TYPES.META">
              <el-upload action="" :before-upload="coverFileUploader" style="display: inline-block">
                <el-button>上传封面</el-button>
              </el-upload>
            </div>
          </template>
        </template>

        <!-- Image / Audio Layout -->
        <template v-else>
          <div class="grid-item-span-4">
            <div class="material-wrapper">
              <img
                v-if="imageType === IMAGE_TYPES.IMAGE || imageType === IMAGE_TYPES.PLAYABLE"
                :src="formItem.addr ? formItem.addr : require('@/assets/images/audio.png')"
                class="item-background"
              />
              <template v-if="imageType === IMAGE_TYPES.GROUP_IMAGE">
                <img v-if="formItem.overviewAddr" :src="formItem.overviewAddr" class="item-background" />
              </template>

              <div v-else class="item-bg-color"></div>
              <img
                v-if="imageType === IMAGE_TYPES.IMAGE || imageType === IMAGE_TYPES.PLAYABLE"
                :src="formItem.addr"
                class="img-item-vertical"
              />

              <template v-if="imageType === IMAGE_TYPES.GROUP_IMAGE">
                <img v-if="formItem.overviewAddr" :src="formItem.overviewAddr" class="img-item-vertical" />
                <span v-if="!formItem.overviewAddr && formItem.id"
                  >缩略图正在生成中... <el-button type="text" @click="emit('refresh', formItem.id)">刷新</el-button>
                </span>
              </template>
            </div>
          </div>

          <div class="grid-item-span-2">
            <el-button v-if="imageType === IMAGE_TYPES.GROUP_IMAGE" @click="onShowGroupImageEditModal">编辑</el-button>

            <el-upload v-else action="" :before-upload="imgFileUploader" style="display: inline-block">
              <el-button v-if="imageType === IMAGE_TYPES.IMAGE">替换图片</el-button>
              <el-button v-else-if="imageType === IMAGE_TYPES.LOGO">替换LOGO</el-button>
              <el-button v-else-if="imageType === IMAGE_TYPES.AUDIO">替换封面</el-button>
            </el-upload>
          </div>
          <div class="grid-item-span-2"></div>
        </template>
      </div>
      <div class="info-tab">
        <el-tabs v-model="mediaRejActiveName" @tab-click="onQueryMediaRejInfo">
          <el-tab-pane label="基础信息" :name="MEDIA_REJ_ACTIVE_NAME.INFO"></el-tab-pane>
          <el-tab-pane label="媒体拒审" :name="MEDIA_REJ_ACTIVE_NAME.LIST"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="material-grid" v-if="mediaRejActiveName === MEDIA_REJ_ACTIVE_NAME.INFO">
        <div class="grid-item-span-2 property-item">
          <span class="col-item">素材名称</span>
          <div class="content-item">
            <el-tooltip
              effect="dark"
              :content="formItem.imageDetailName"
              placement="top-start"
              :open-delay="500"
              v-if="formItem.imageDetailName"
            >
              <span class="tool-span" style="width: 390px">{{ formItem.imageDetailName }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">ID</span>
          <div class="content-item">
            <span>{{ formItem.id }}</span>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">尺寸</span>
          <div class="content-item">
            <span v-if="formItem.width">{{ formItem.width }} X {{ formItem.height }}</span>
            <span v-else></span>
          </div>
        </div>

        <!-- Row 2 -->
        <div class="grid-item-span-2 property-item">
          <span class="col-item">母素材名称</span>
          <div class="content-item">
            <el-tooltip effect="dark" :content="formItem.imageName" placement="top-start" :open-delay="500" v-if="formItem.imageName">
              <span class="tool-span" style="width: 390px">{{ formItem.imageName }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">母素材ID</span>
          <div class="content-item">
            <span>{{ formItem.imageId }}</span>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">大小</span>
          <div class="content-item">
            <span>{{ formItem.size }} M</span>
          </div>
        </div>

        <!-- Row 3 -->
        <div class="grid-item-span-1 property-item">
          <span class="col-item">设计人</span>
          <div class="content-item">
            <span>{{ formItem.designerName }}</span>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">策划人</span>
          <div class="content-item">
            <el-tooltip effect="dark" :content="formItem.plannerName" placement="top-start" :open-delay="500" v-if="formItem.plannerName">
              <span class="tool-span" style="width: 180px">{{ formItem.plannerName }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">渲染设计</span>
          <div class="content-item">
            <el-tooltip effect="dark" :content="formItem.renderName" placement="top-start" :open-delay="500" v-if="formItem.renderName">
              <span class="tool-span" style="width: 180px">{{ formItem.renderName }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">动画设计</span>
          <div class="content-item">
            <el-tooltip
              effect="dark"
              :content="formItem.animationName"
              placement="top-start"
              :open-delay="500"
              v-if="formItem.animationName"
            >
              <span class="tool-span" style="width: 130px">{{ formItem.animationName }}</span>
            </el-tooltip>
          </div>
        </div>

        <div class="grid-item-span-1 property-item">
          <span class="col-item">模型地编</span>
          <div class="content-item">
            <el-tooltip effect="dark" :content="formItem.tcmName" placement="top-start" :open-delay="500" v-if="formItem.tcmName">
              <span class="tool-span" style="width: 180px">{{ formItem.tcmName }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">原画</span>
          <div class="content-item">
            <span v-if="formItem.paintingName">{{ formItem.paintingName }}</span>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">来源</span>
          <div class="content-item">
            <span v-if="imageType === IMAGE_TYPES.SHOT">AI自动切片</span>
            <template v-else>
              <span v-if="formItem.source">
                {{ formItem.source ? SOURCE_TYPES.find((s) => s.value === formItem.source).label : '-' }}
              </span>
            </template>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">营销主题标签</span>
          <div class="content-item">
            <el-tooltip
              effect="dark"
              :content="formItem.typeLabelNames"
              placement="top-start"
              :open-delay="500"
              v-if="formItem.typeLabelNames"
            >
              <span class="tool-span" style="width: 130px">{{ formItem.typeLabelNames }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="grid-item-span-2 property-item">
          <span class="col-item">一级素材样式</span>
          <div class="content-item">
            <el-tag class="tag-item" v-for="(tagName, index) in splitTagNamesInList(formItem.imageStyle1LabelNames)" :key="index">
              {{ tagName }}
            </el-tag>
          </div>
        </div>

        <div class="grid-item-span-2 property-item">
          <span class="col-item">二级素材样式</span>
          <div class="content-item">
            <el-tag class="tag-item" v-for="(tagName, index) in splitTagNamesInList(formItem.imageStyle2LabelNames)" :key="index">
              {{ tagName }}
            </el-tag>
          </div>
        </div>
        <div class="grid-item-span-2 property-item">
          <span class="col-item">3D视频源</span>
          <div class="content-item">
            <el-tag class="tag-item" v-for="(tagName, index) in splitTagNamesInList(formItem.videoLabelNames)" :key="index">
              {{ tagName }}
            </el-tag>
          </div>
        </div>
        <div class="grid-item-span-2 property-item">
          <span class="col-item">内容标签</span>
          <div class="content-item">
            <!-- <el-tooltip effect="dark" :content="formItem.labelNames" placement="top-start" :open-delay="500" v-if="formItem.labelNames">
              <span class="tool-span" style="width: 400px">{{ formItem.labelNames }}</span>
            </el-tooltip> -->

            <el-tag class="tag-item" v-for="(tagName, index) in splitTagNamesInList(formItem.labelNames)" :key="index">
              {{ tagName }}
            </el-tag>
          </div>
        </div>

        <!-- Row 7 (Media Limit / Time / Time) -->
        <div class="grid-item-span-2 property-item">
          <span class="col-item">媒体限制</span>
          <div class="content-item">
            <el-tooltip
              effect="dark"
              :content="formItem.excludeMediaNames"
              placement="top-start"
              :open-delay="500"
              v-if="formItem.excludeMediaNames"
            >
              <span class="tool-span" style="width: 400px">{{ formItem.excludeMediaNames }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">绩效起始时间</span>
          <div class="content-item">
            <span>{{ formItem.imageLauchTime }}</span>
          </div>
        </div>
        <div class="grid-item-span-1 property-item">
          <span class="col-item">上传时间</span>
          <div class="content-item">
            <span>{{ formItem.createTime }}</span>
          </div>
        </div>

        <!-- Row 8 (Game / Playable ID) -->
        <div class="grid-item-span-2 property-item">
          <span class="col-item">游戏</span>
          <div class="content-item">
            <el-tooltip effect="dark" :content="formItem.gameNames" placement="top-start" :open-delay="500" v-if="formItem.gameNames">
              <span class="tool-span">{{ formItem.gameNames }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="grid-item-span-2 property-item" v-if="imageType === IMAGE_TYPES.PLAYABLE">
          <span class="col-item">试玩ID</span>
          <div class="content-item">
            <div class="playable-id">
              <el-input v-if="playableEditState" size="mini" v-model.trim="formItem.gdtPlayableId"></el-input>
              <span v-else :title="formItem.gdtPlayableId" class="tool-span" style="flex-basis: 90%">
                {{ formItem.gdtPlayableId }}
              </span>
              <span
                v-if="playableEditState"
                :class="playableEditLoading ? 'el-icon-loading' : 'el-icon-check'"
                class="playable-edit-icon"
                @click="onPlayableIdEditConfirm"
              ></span>
              <span v-else class="playable-edit-icon el-icon-edit" @click="playableEditState = true"></span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="mediaRejActiveName === MEDIA_REJ_ACTIVE_NAME.LIST" class="media-rejection-list">
        <el-table
          v-loading="mediaRejLoading"
          class="common-el-table-styles"
          stripe
          border
          style="width: 100%"
          :data="rejectionData"
          :height="290"
        >
          <el-table-column prop="mediaName" label="媒体" width="120" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="excludeMediaNames" label="限制投放媒体" width="140">
            <template slot-scope="{ row }">
              <p v-if="row.excludeMediaNames">{{ row.excludeMediaNames }}</p>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="mediaImageId" label="媒体素材ID" width="160" show-overflow-tooltip> </el-table-column>
          <el-table-column label="计划名称和ID" width="200" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <p>{{ row.adName }}</p>
              <p>
                ID：
                <span type="text">{{ row.adId }}</span>
                <span v-clipboard:copy="row.adId" v-clipboard:success="onCopySucc" class="copy-btn el-icon-copy-document"></span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="launchOpName" label="广告投放人员" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="账号名称和ID" width="200" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <p>{{ row.accountName }}</p>
              <p>
                ID：
                <span type="text">{{ row.advertiserId }}</span>
                <span v-clipboard:copy="row.advertiserId" v-clipboard:success="onCopySucc" class="copy-btn el-icon-copy-document"></span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="rejectReason" label="拒审理由" show-overflow-tooltip> </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right"
          :total="mediaRefPager.total"
          :current-page.sync="mediaRefPager.pageIndex"
          :page-size.sync="mediaRefPager.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="onQueryMediaRejInfo"
          @size-change="onMediaRejSizeChange"
          background
        />
      </div>
    </div>
    <el-dialog width="510px" custom-class="group-image-edit-modal" title="编辑组图" :visible.sync="showGroupImageEditModal" append-to-body>
      <ImageGroupMaterial
        v-for="(images, index) in groupImageList"
        :key="images.map((i) => i.id).join('')"
        :images.sync="groupImageList[index]"
        :index="index"
        draggable
        :show-desc="true"
        :show-badge="false"
        :show-remove="false"
        @upload="onGroupImageReplace"
      >
      </ImageGroupMaterial>

      <el-upload
        v-show="false"
        ref="groupImageUploaderRef"
        class="group-image-replace-upload"
        :action="uploadUrl"
        :show-file-list="false"
        :on-success="onGroupImageUploadSuccess"
        :before-upload="onGroupImageBeforeUpload"
        with-credentials
      >
        <i slot="default" class="el-icon-plus"></i>
      </el-upload>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onGroupImageReplaceCancel">取 消</el-button>
        <el-button type="primary" :loading="groupImageReplaceLoading" @click="onGroupImageReplaceConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script setup>
import { ref, computed, onMounted, getCurrentInstance, nextTick } from 'vue'
import { HOST_API } from '@/api/config'
import SubtitleDisplayForm from './material-model-subtitles.vue'
import ImageGroupMaterial from '@/views/create/gdt/v3/components/creative/image-group.vue'
import { timeStringToSeconds } from '@/common/js/utils.js'
import { updateGdtPlayableId, scriptShotMatch } from '@/api/material.model'
import { useMaterialDetailMediaRejection } from '../hooks/useMediaRejections'
import { useGroupImageUpload } from '../hooks/useGroupImage.js'
import { IMAGE_TYPES_STR_VAL as IMAGE_TYPES } from '@/views/material/uploading/consts.js'
import { SOURCE_TYPES } from '../../tags/const'

const timeSeparator = ' --> '
// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Boolean
  },
  formItem: {
    type: Object
  },
  imageType: {
    type: String
  },
  loading: {
    type: Boolean
  }
})
// eslint-disable-next-line
const emit = defineEmits(['input', 'on-upload', 'on-upload-base', 'refresh'])

// 获取当前实例
const { proxy } = getCurrentInstance()

const uploadUrl = `${HOST_API}/api/ptom/imageInfo/upload`
// Refs
const materVideoRef = ref(null)

// Reactive data
const playableEditState = ref(false)
const playableEditLoading = ref(false)
const subtitleList = ref([])
const similarShotPreviewList = ref([])
const similarSearchLoading = ref(false)
const similarVideoShotAiContent = ref(null)
// Computed
const state = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('input', val)
  }
})

const {
  MEDIA_REJ_ACTIVE_NAME,
  mediaRejLoading,
  mediaRejActiveName,
  mediaRefPager,
  rejectionData,
  onQueryMediaRejInfo,
  onMediaRejSizeChange
} = useMaterialDetailMediaRejection(props)

const {
  groupImageUploaderRef,
  showGroupImageEditModal,
  submitLoading: groupImageReplaceLoading,
  groupImageList,
  onShowGroupImageEditModal,
  onGroupImageReplace,
  onGroupImageBeforeUpload,
  onGroupImageUploadSuccess,
  onGroupImageReplaceConfirm,
  onGroupImageReplaceCancel
} = useGroupImageUpload(proxy, props, emit)

const aiContent = computed(() => {
  if (similarVideoShotAiContent.value) {
    return {
      video_desc: similarVideoShotAiContent.value
    }
  }
  if (props.formItem.aiContent) {
    return JSON.parse(props.formItem.aiContent)
  }
  return {}
})
const getShotMaterialItems = () => {
  similarVideoShotAiContent.value = null
  const videoDesc = aiContent.value.video_desc
  if (!videoDesc) return
  if (props.imageType !== IMAGE_TYPES.SHOT) return
  const segment = {
    ...videoDesc,
    key_elements: videoDesc.key_elements.join('、')
  }
  similarShotPreviewList.value = []
  similarSearchLoading.value = true
  scriptShotMatch({ task_type: 1, top_k: 3, image_detail_id: props.formItem.id, segment })
    .then((data) => {
      similarShotPreviewList.value = data
    })
    .finally(() => {
      similarSearchLoading.value = false
    })
}

const onSimilarVideoPlay = (video) => {
  if (!materVideoRef.value.paused) {
    materVideoRef.value.pause()
  }
  const { name, visual_core, content_narrative_focus, emotion_atmosphere, key_elements } = video
  if (visual_core && content_narrative_focus && emotion_atmosphere) {
    similarVideoShotAiContent.value = {
      name,
      visual_core,
      content_narrative_focus,
      emotion_atmosphere,
      key_elements
    }
  } else {
    similarVideoShotAiContent.value = null
  }

  materVideoRef.value.src = video.url
  nextTick(() => {
    materVideoRef.value.play()
  })
}

// Methods
const onModalClose = () => {
  subtitleList.value = []
  mediaRejActiveName.value = MEDIA_REJ_ACTIVE_NAME.INFO
  mediaRefPager.value.pageIndex = 1
}

const onModalOpen = () => {
  getShotMaterialItems()

  const { subtitles } = props.formItem
  if (!subtitles || !subtitles.length) {
    subtitleList.value = []
    return
  }
  const list = subtitles
    .split('\n')
    // 去掉前两项
    .slice(2)
    // 过滤空字符
    .filter((s) => !!s)

  const subtitleListData = []
  for (let i = 0; i < list.length; i++) {
    const subtitle = list[i]
    const timerange = list[i - 1]

    // 每两组组成一个时间轴字幕结构
    if (i % 2 === 1) {
      subtitleListData.push({ timerange, subtitle })
    }
  }

  subtitleList.value = subtitleListData
}

const onVideoPlayUpdateTimeStamp = (e) => {
  const currentTime = e.target.currentTime
  const timestampsElements = document.querySelectorAll('.meta-video-subtitles .timestamps')

  for (let i = 0; i < subtitleList.value.length; i++) {
    const { timerange } = subtitleList.value[i]

    if (timerange.includes(timeSeparator)) {
      const [start, end] = timerange.split(timeSeparator).map(timeStringToSeconds)

      // 播放时的高亮显示
      if (start && end && currentTime > start && currentTime < end) {
        timestampsElements.forEach((el) => {
          el.nextElementSibling.classList.remove('active')
          if (el.textContent.includes(timerange)) {
            el.nextElementSibling.classList.add('active')
            el.scrollIntoView()
          }
        })
      }
    }
  }
}

const onSubtitleEdit = () => {
  const video = materVideoRef.value
  if (video) {
    video.pause()
  }
}

const onPlayableIdEditConfirm = () => {
  const { id, gdtPlayableId } = props.formItem
  if (!gdtPlayableId) {
    return proxy.$message.warning('试玩ID不能为空')
  }
  if (gdtPlayableId.length > 150) {
    return proxy.$message.warning('试玩ID长度不能超过150个字符')
  }
  if (playableEditLoading.value) return
  playableEditState.value = false
  playableEditLoading.value = true
  updateGdtPlayableId({ imageDetailId: id, gdtPlayableId })
    .then((data) => {
      if (data) {
        proxy.$message.success('试玩ID修改成功')
      }
    })
    .finally(() => {
      playableEditLoading.value = false
    })
}

const videoFileUploader = (file) => {
  const { size, name, type } = file
  // 验证
  if (
    !['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/webm', 'video/ogg', 'application/octet-stream'].includes(
      type
    )
  ) {
    proxy.$message.error({
      showClose: true,
      duration: 5000,
      message: `上传的视频文件 ${name} 格式错误，只支持 mp4、wmv、webm、flv 格式 `
    })
    return false
  }
  if (size > 1024 * 1024 * 300) {
    proxy.$message.error({
      showClose: true,
      duration: 5000,
      message: `上传的视频文件 ${name} 超过限制大小 300M`
    })
    return false
  }
  emit('on-upload', file, props.imageType, props.formItem.id)
  return true
}

const coverFileUploader = (file) => {
  const { size, name, type } = file
  if (!['image/png', 'image/gif', 'image/jpeg'].includes(type)) {
    proxy.$message.error({
      showClose: true,
      duration: 5000,
      message: `上传的图片 ${name} 格式错误，只支持 jpg、jpeg、png、gif 格式 `
    })
    return false
  }
  if (size > 1024 * 1024 * 10) {
    proxy.$message.error({
      showClose: true,
      duration: 5000,
      message: `上传的图片 ${name} 超过限制大小 10M`
    })
    return false
  }
  emit('on-upload', file, 3, props.formItem.id)
  return true
}

const imgFileUploader = (file) => {
  const { size, name, type } = file
  if (!['image/png', 'image/gif', 'image/jpeg'].includes(type)) {
    proxy.$message.error({
      showClose: true,
      duration: 5000,
      message: `上传的图片 ${name} 格式错误，只支持 jpg、jpeg、png、gif 格式 `
    })
    return false
  }
  if (size > 1024 * 1024 * 10) {
    proxy.$message.error({
      showClose: true,
      duration: 5000,
      message: `上传的图片 ${name} 超过限制大小 10M`
    })
    return false
  }
  const uploadType = props.imageType ? Number(props.imageType) : 4
  emit('on-upload', file, uploadType, props.formItem.id)
  return true
}

const handleParse = () => {
  const video = materVideoRef.value
  if (!video) return
  video.pause()
  const canvas = window.document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  canvas.width = video.videoWidth
  canvas.height = video.videoHeight
  ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

  const base64Img = canvas.toDataURL('image/png')
  if (!base64Img) {
    proxy.$message.error('图片生成Base64失败!')
    return
  }
  emit('on-upload-base', base64Img.substring(22), props.formItem.id)
}

const splitTagNamesInList = (names) => {
  return names && typeof names === 'string' ? names.split(',') : []
}
const preloadData = () => {}

const onCopySucc = () => {
  proxy.$Message.success('复制成功')
}

// Lifecycle
onMounted(() => {
  preloadData()
})
</script>
<style lang="scss">
.group-image-edit-modal {
  .el-dialog__body {
    padding: 0 10px;
  }
}
</style>
<style lang="scss" scoped>
::v-deep .num-txt {
  color: red;
  display: inline-block;
}

.material-detail-container {
  padding-bottom: 10px;
}

.info-tab {
  margin-top: 20px;
}

/* Grid Layout */
.material-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px 24px;
}

.grid-item-span-1 {
  grid-column: span 1;
}

.grid-item-span-2 {
  grid-column: span 2;
}

.grid-item-span-4 {
  grid-column: span 4;
}

/* Responsive */
@media (max-width: 992px) {
  .material-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-item-span-1 {
    grid-column: span 1;
  }
  .grid-item-span-2 {
    grid-column: span 2;
  }
  .grid-item-span-4 {
    grid-column: span 2;
  }
}

.meta-video-subtitles {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  height: calc(100%);
}
.similar-shot-preview {
  display: flex;
  margin-top: 6px;
  overflow: auto;
  .redo {
    white-space: nowrap;
    height: 62px;
    line-height: 62px;
    text-align: center;
    background: #eee;
    padding: 0 8px;
    cursor: pointer;
  }
  .video-box {
    height: 62px;
    margin-right: 10px;
    position: relative;
    .score {
      white-space: nowrap;
      display: block;
      background: rgba(255, 255, 255, 0.7);
      position: absolute;
      font-size: 12px;
      left: 0;
      top: 0;
      padding: 0 2px;
      z-index: 1;
      letter-spacing: -1px;
      transform: scale(0.9);
      transform-origin: left top;
    }
    video {
      height: 100%;
    }
  }
}
.shot-detail {
  h3 {
    margin-bottom: 20px;
  }
  p {
    display: flex;
    margin-bottom: 10px;
    max-height: 90px;
    overflow: auto;
    .title {
      font-weight: 700;
      display: inline-block;
      min-width: 120px;
    }
  }
}

.copy-btn {
  cursor: pointer;
  margin-left: 6px;
}

/* Property Item Styles */
.property-item {
  position: relative;
  /* Ensure content doesn't overflow grid item */
  min-width: 0;

  .col-item {
    font-weight: bold;
    margin-right: 10px;
    display: inline-block;
    vertical-align: top;
  }

  .content-item {
    display: inline-block;
    position: relative; /* Changed from absolute */
    width: calc(100% - 100px); /* Adjust based on label width approx */
    overflow: hidden;
    // white-space: nowrap;
    vertical-align: top;

    .playable-id {
      display: flex;
      align-items: center;
      .playable-edit-icon {
        display: inline-block;
        flex: 1;
        text-align: right;
        cursor: pointer;
      }
    }

    .tag-item {
      margin-right: 2px;
      margin-bottom: 1px;
      height: 18px;
      line-height: 16px;
    }

    .tool-span {
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%; /* Take available space */
    }
  }
}

.subtitle-row {
  display: flex;
  align-items: center;
  .subtitle-contents {
    display: inline-block;
    width: 380px;
    overflow: hidden;
    white-space: no-wrap;
    text-overflow: ellipsis;
  }
  .edit-icon {
    margin-left: 10px;
    cursor: pointer;
  }
}

.material-wrapper {
  width: 100%;
  height: 270px;
  overflow: hidden;
  position: relative;

  .video-item {
    width: 100%;
    height: 100%;
  }

  .img-item-cross {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .img-item-vertical {
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .item-background {
    width: 100%;
    height: 100%;
    filter: blur(10px);
    position: absolute;
  }

  .item-bg-color {
    width: 100%;
    height: 100%;
    background-color: #3b3b3b;
  }

  .photo-item {
    width: 100%;
    height: 100%;
  }
}
.edit-subtitle {
  text-align: right;
  cursor: pointer;
  font-size: 12px;

  .icon {
    margin-right: 10px;
    &:hover {
      color: #1974ff;
    }
  }
}
.subtitle-inputs {
  max-height: 220px;
  overflow: auto;
  .subtitle-group {
    margin-bottom: 12px;
    position: relative;

    .active {
      background: #d7f2ff;
    }

    .timestamps {
      color: #b5b5b5;
    }

    .cut-icon {
      position: absolute;
      right: 10px;
      top: 30px;
      z-index: 1;
      opacity: 0.4;
    }
  }
}
</style>
